import { AlertBar, Icon, Tooltip } from '@civilgrid/ui/components';
import { useIsSandboxOrg } from '~/hooks/useIsSandboxOrg';

export default function SandboxBanner() {
  const isSandboxOrg = useIsSandboxOrg();

  if (!isSandboxOrg()) {
    return null;
  }

  return (
    <div data-testid="sandbox-banner">
      <AlertBar
        variant="danger"
        layout="banner"
        title={
          <span className="inline-flex items-center gap-2">
            Sandbox Organization
            <Tooltip
              aria-label="About Sandbox Organization"
              data-testid="sandbox-banner-info"
              text="This is a temporary Sandbox Organization to explore CivilGrid. No actions in the Sandbox Organization will incur a cost."
            >
              <Icon icon="infoCircled" size={14} />
            </Tooltip>
          </span>
        }
      />
    </div>
  );
}
